export default "__VITE_ASSET__CfpE$1ON__"